import React from 'react';

type UnderlineInputProps = {
  id?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  placeholder?: string;
  className?: string;
};

const UnderlineInput: React.FC<UnderlineInputProps> = ({
  id,
  value,
  onChange,
  type = 'text',
  placeholder = '',
  className = '',
}) => (
  <input
    id={id}
    type={type}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    className={`w-full border-b border-gray-300 focus:border-primary focus:outline-none px-1 py-1 bg-transparent ${className}`}
  />
);

export default UnderlineInput;
